import React, { useEffect, useState } from 'react';
import '../styles/ModalVendas.css';
import { dataAtual } from '../components/utils';
import { consultaVenda, consultaItensVenda, geraNFC, statusNfe, getDanfe, consultaPagamentosById } from '../services/api';
import { getPagamentosByVendaId } from '../services/ApiPagamentos/ApiPagamentos';
import { getTefTransacoes, imprimirComprovante, cancelaTefPayment } from '../services/ApiTef/ApiTef';

import { imprimeVenda } from '../utils/impressaovenda';
import Toast from '../components/Toast';
import ConfirmDialog from '../components/ConfirmDialog'; // Componente para o modal de confirmação
import ComunicacaoSEFAZ from '../components/ComunicacaoSEFAZ'; // Componente para comunicação com SEFAZ
import { useAuth } from '../context/AuthContext';
import { usePermissionModal } from "../hooks/usePermissionModal";




const ModalVendas = ({
    isOpen,
    onClose,
    totalQuantity,
    totalPrice = 0,
}) => {
    const [vendas, setVendas] = useState([]);
    const [filteredVendas, setFilteredVendas] = useState([]);
    const [filterDate, setFilterDate] = useState(dataAtual());
    const [itensVenda, setItensVenda] = useState([]);
    const [pagamentos, setPagamentos] = useState([]);
    const [mensagem, setMensagem] = useState('');

    const [transacaoId, setTransacaoId] = useState('');
    const [tefProcessing, setTefProcessing] = useState(false);
    const [cancelaTEFTransaction, setCancelaTEFTransaction] = useState(false);
    const [selectedVendaId, setSelectedVendaId] = useState(null);
    const [idVenda, setIdVenda] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingDetalheId, setLoadingDetalheId] = useState(null);
    const [toast, setToast] = useState({ message: '', type: '' });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [isComunicacaoSefazOpen, setIsComunicacaoSEFAZOpen] = useState(false);
    const { permissions } = useAuth();
    const { checkPermission, PermissionModalUI } = usePermissionModal(permissions);




    useEffect(() => {
        if (toast.message) {
            const timer = setTimeout(() => setToast({ message: '', type: '' }), 3000);
            return () => clearTimeout(timer);
        }
    }, [toast]);

    const handleDetalheClick = async (vendaId) => {
        if (selectedVendaId === vendaId) {
            setSelectedVendaId(null);
            setItensVenda([]);
            return;
        }

        setLoadingDetalheId(vendaId); // só a linha clicada
        try {
            await handleBuscarItens(vendaId); // chamada ao endpoint
            await handleBuscaPagamento(vendaId);
            setSelectedVendaId(vendaId);
        } catch (err) {
            console.error("Erro ao buscar itens da venda:", err);
        } finally {
            setLoadingDetalheId(null); // remove o spinner
        }
    };


    // Dentro do seu componente React
    const handleImprimir = async (transacao) => {
        try {
            const res = await imprimirComprovante(transacao.transacaoId);
        } catch (error) {
            setToast({ message: 'Erro ao gerar comprovante.', type: 'error' });
            console.error('Erro ao gerar comprovante:', error);
        } finally {

        }
    };

    const handleCancel = () => {
        setIsConfirmationModalOpen(false); // Fechar o modal sem realizar nada
    };

    const handleCancelar = (transacaoId) => {
        setCancelaTEFTransaction(true);
        checkPermission('movimentacaotef', 'delete', () => {
            setTransacaoId(transacaoId);
            setIsConfirmationModalOpen(true);
        })
    };

    const confirmaCancelamentoTEF = async () => {
        try {
            setIsConfirmationModalOpen(false);
            setTefProcessing(true);
            setMensagem('Cancelamento');
            const response = await cancelaTefPayment({ intencaoVendaId: transacaoId.transacaoId });
            if (response.success) {
                setToast({ message: "Transação cancelada com sucesso!", type: "success" });
            } else {
                setToast({ message: `Erro ao cancelar a transação: ${response.error}`, type: "error" });
            }
        } catch (error) {
            console.error("Erro ao cancelar a transação:", error);
            setToast({ message: "Ocorreu um erro ao cancelar a transação.", type: "error" });
        } finally {
            setIsConfirmationModalOpen(false);
            setTransacaoId('');
            setTefProcessing(false);
            setMensagem('');
        }
    };

    const fetchVendas = async () => {
        try {
            setLoading(true); // Ativa o estado de carregamento
            setLoadingDetalheId(null);
            setSelectedVendaId(null); // Limpa a venda selecionada ao buscar novas vendas
            const response = await consultaVenda({ data: filterDate }); // Passa a data como parâmetro
            if (response.status === 200) {

                if (response.data.transacoes.length === 0) {
                    setToast({ message: 'Nenhum resultado encontrado.', type: 'warning' });
                } else {
                    setVendas(response.data.transacoes);
                    setFilteredVendas(response.data.transacoes);
                    setToast({ message: 'Vendas encontradas com sucesso.', type: 'success' });
                }
            } else if (response.status === 403) {
                window.location.href = '/login';
            } else {
                setToast({ message: 'Nenhum resultado encontrado.', type: 'warning' });

                console.error('Erro ao obter as vendas:', response);
            }
        } catch (err) {
            if (err.response && err.response.status === 403) {
                // Redireciona para a página de login
                window.location.href = '/login';
            } else {
                console.error('Erro ao tentar buscar as vendas:', err);
            }
        } finally {
            setLoading(false); // Desativa o estado de carregamento
        }
    };

    const handleBuscaPagamento = async (vendaId) => {
        try {
            const pagamento = await getPagamentosByVendaId(vendaId);
            if (pagamento.length === 0) {
                setToast({ message: 'Nenhum pagamento encontrado para esta venda.', type: 'warning' });
                return null;
            } else {
                setPagamentos(pagamento);
            }
        } catch (error) {
            console.error('Erro ao buscar pagamento:', error);
            return null;
        }
    }
    const handleBuscarItens = async (idVenda) => {
        try {
            const response = await consultaItensVenda(idVenda); // Supondo que você passe o ID para a API
            if (response.status === 200) {
                setItensVenda(response.data);
                setSelectedVendaId(idVenda);
            } else {
                console.error('Erro inesperado ao obter os itens da venda:', response);
            }
        } catch (err) {
            if (err.response && err.response.status === 403) {
                // Redireciona para a página de login
                window.location.href = '/login';
            } else {
                console.error('Erro ao obter os itens da venda:', err);
            }
        }
    };

    const handleImprimeVenda = async (venda) => {
        try {
            setLoading(true);

            const status = await statusNfe(venda.id);
            if (status.response === 'AUTORIZADA') {
                await getDanfe(venda.id); // Vai abrir o PDF no navegador
            } else {
                imprimeVenda(venda.id)
            }

        } catch (error) {
            console.error('Erro ao imprimir DANFE NFC-e:', error);
            alert('Erro ao imprimir DANFE NFC-e');
        } finally {
            setLoading(false);
        }
    };



    const handleFilterChange = (e) => {
        const date = e.target.value;
        setFilterDate(date);

        if (date) {
            const filtered = vendas.filter((venda) => {
                const createdAt = new Date(venda.data).toISOString().split('T')[0];
                return createdAt === date;
            });
            setFilteredVendas(filtered);
        } else {
            setFilteredVendas(vendas);
        }
    };

    useEffect(() => {
        if (isOpen) {
            fetchVendas();
        }
    }, [isOpen, filterDate]);

    const handleConfirmacaoEmitirNFCe = (venda_id) => {
        setIdVenda(venda_id);
        setIsConfirmationModalOpen(true);
    }

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEmitirNFCe = async () => {

        setIsConfirmationModalOpen(false);
        setIsComunicacaoSEFAZOpen(true);

        try {
            const response = await geraNFC(idVenda);
            if (response.status === 200) {
                setToast({
                    message: "NF-e autorizada com sucesso!",
                    type: "success",
                });
            } else if (response.status === 412) {
                const data = await response.data;
                setToast({
                    message: `NF-e rejeitada: ${data.motivo || data.erro || "Motivo não informado"}`,
                    type: "error",
                });
            } else {
                setToast({
                    message: "Erro inesperado na emissão da NF-e.",
                    type: "error",
                });
            }
        } catch (error) {
            setToast({
                message: `Erro na comunicação: ${error.message}`,
                type: "error",
            });
        } finally {
            setIsComunicacaoSEFAZOpen(false);
        }
    };


    // Calcular o total de vendas e o total de descontos
    const totalVendas = filteredVendas.reduce((acc, venda) => acc + parseFloat(venda.valor), 0);
    const totalDescontos = filteredVendas.reduce((acc, venda) => acc + parseFloat(venda.desconto), 0);

    return (

        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-lg w-full max-w-5xl max-h-[90vh] overflow-y-auto relative p-6">
                {/* Cabeçalho */}
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h2 className="text-xl font-bold">Vendas</h2>
                    <button
                        className="text-gray-500 hover:text-red-500 text-lg"
                        onClick={onClose}
                    >
                        ✖
                    </button>
                </div>

                {/* Filtro */}
                <div className="flex flex-wrap gap-3 mb-4 items-center">
                    <div className="flex items-center gap-2 bg-gray-100 rounded-lg px-3 py-1 shadow-sm">
                        <span>📅</span>
                        <input
                            type="date"
                            value={filterDate}
                            onChange={handleFilterChange}
                            className="bg-transparent border-none text-sm focus:outline-none"
                        />
                    </div>
                </div>

                {/* Loading */}
                {loading ? (
                    <div className="flex justify-center items-center py-6">
                        <div className="animate-spin w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full"></div>
                    </div>
                ) : (
                    <>
                        {/* Tabela de Vendas */}
                        <div className="overflow-x-auto border rounded-lg">
                            <table className="w-full text-sm">
                                <thead className="bg-gray-100 text-gray-700">
                                    <tr>
                                        <th className="p-2 text-left">ID</th>
                                        <th className="p-2 text-left">Cliente</th>
                                        <th className="p-2 text-left">Desconto</th>
                                        <th className="p-2 text-left">Total</th>
                                        <th className="p-2 text-left">Qtd</th>
                                        <th className="p-2 text-left">Data</th>
                                        <th className="p-2 text-center">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredVendas.map((venda) => (
                                        <React.Fragment key={venda.id}>
                                            <tr
                                                className={`border-b cursor-pointer transition-colors duration-200 ${selectedVendaId === venda.id ? 'bg-blue-50 shadow-inner' : 'hover:bg-gray-50'
                                                    }`}
                                            >
                                                <td className="p-2">{venda.id}</td>
                                                <td className="p-2">{venda.cliente || "Não Informado"}</td>
                                                <td className="p-2">
                                                    {new Intl.NumberFormat("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL",
                                                    }).format(venda.desconto || 0)}
                                                </td>
                                                <td className="p-2 font-semibold">
                                                    {new Intl.NumberFormat("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL",
                                                    }).format(venda.valor)}
                                                </td>
                                                <td className="p-2">{venda.totalQuantity || "N/A"}</td>
                                                <td className="p-2">{new Date(venda.data).toLocaleString().replace(",", "")}</td>
                                                <td className="p-2 text-center space-x-1">
                                                    {venda.descricao === "Venda" && (
                                                        <div className="flex justify-center gap-2">
                                                            <button
                                                                title="Detalhes"
                                                                className="p-2 bg-gray-200 rounded hover:bg-gray-300"
                                                                onClick={() => handleDetalheClick(venda.id)}
                                                            >
                                                                🔍
                                                                {loadingDetalheId === venda.id && (
                                                                    <span className="animate-spin text-xs">⏳</span>
                                                                )}
                                                            </button>

                                                            <button
                                                                title="Imprimir"
                                                                className="p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                                                onClick={() => handleImprimeVenda(venda)}
                                                                disabled={loading}
                                                            >
                                                                {loading ? "..." : "🖨"}
                                                            </button>
                                                            <button
                                                                title="Emitir NFC-e"
                                                                className="p-2 bg-green-500 text-white rounded hover:bg-green-600"
                                                                onClick={() => handleConfirmacaoEmitirNFCe(venda.id)}
                                                            >
                                                                📤
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>

                                            {selectedVendaId === venda.id && (
                                                <tr className="bg-gray-50">
                                                    <td colSpan="8" className="p-2">
                                                        {/* Itens da venda */}
                                                        {itensVenda.length > 0 ? (
                                                            <div className="overflow-x-auto border rounded-lg mb-2">
                                                                <table className="w-full text-sm">
                                                                    <thead className="bg-gray-100 text-gray-700">
                                                                        <tr>
                                                                            <th className="p-2 text-left">Produto</th>
                                                                            <th className="p-2 text-left">Qtd</th>
                                                                            <th className="p-2 text-left">Unitário</th>
                                                                            <th className="p-2 text-left">Subtotal</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {itensVenda.map((item) => (
                                                                            <tr key={item.id} className="border-b">
                                                                                <td className="p-2">{item.xProd}</td>
                                                                                <td className="p-2">{item.quantity}</td>
                                                                                <td className="p-2">
                                                                                    {new Intl.NumberFormat("pt-BR", {
                                                                                        style: "currency",
                                                                                        currency: "BRL",
                                                                                    }).format(item.vlrUnitario)}
                                                                                </td>
                                                                                <td className="p-2 font-semibold">
                                                                                    {new Intl.NumberFormat("pt-BR", {
                                                                                        style: "currency",
                                                                                        currency: "BRL",
                                                                                    }).format(item.vlrVenda)}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        ) : (
                                                            <p className="text-gray-500">Sem itens para esta venda.</p>
                                                        )}

                                                        {/* Pagamentos da venda */}
                                                        {pagamentos.length > 0 ? (
                                                            <div className="overflow-x-auto border rounded-lg mt-2">
                                                                <table className="w-full text-sm">
                                                                    <thead className="bg-gray-100 text-gray-700">
                                                                        <tr>
                                                                            <th className="p-2 text-left">Forma de Pagamento</th>
                                                                            <th className="p-2 text-left">Valor Pago</th>
                                                                            <th className="p-2 text-left">Data</th>
                                                                            <th className="p-2 text-left">Ações</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {pagamentos.map((pgto) => (
                                                                            <tr key={pgto.id} className="border-b">
                                                                                <td className="p-2">{pgto.formaPagamento}</td>
                                                                                <td className="p-2 font-semibold">
                                                                                    {new Intl.NumberFormat("pt-BR", {
                                                                                        style: "currency",
                                                                                        currency: "BRL",
                                                                                    }).format(pgto.vlrPago)}
                                                                                </td>
                                                                                <td className="p-2">{new Date(pgto.createdAt).toLocaleString().replace(',', '')}</td>
                                                                                {pgto.transacoesTef.length > 0 && (<td className="py-2 px-4 flex gap-2">
                                                                                    {/* Botão Imprimir */}
                                                                                    <button
                                                                                        onClick={() => handleImprimir(pgto.transacoesTef[0])}
                                                                                        className="text-gray-700 hover:text-black"
                                                                                        title="Imprimir"
                                                                                    >
                                                                                        🖨️
                                                                                    </button>
                                                                                </td>)}
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        ) : (
                                                            <p className="text-gray-500 mt-2">Sem pagamentos registrados.</p>
                                                        )}
                                                    </td>
                                                </tr>
                                            )}

                                        </React.Fragment>
                                    ))}
                                </tbody>

                                <tfoot className="bg-gray-50">
                                    <tr>
                                        <td colSpan="2" className="p-2 font-bold">
                                            Totais
                                        </td>
                                        <td className="p-2 font-bold">
                                            {new Intl.NumberFormat("pt-BR", {
                                                style: "currency",
                                                currency: "BRL",
                                            }).format(totalDescontos)}
                                        </td>
                                        <td className="p-2 font-bold">
                                            {new Intl.NumberFormat("pt-BR", {
                                                style: "currency",
                                                currency: "BRL",
                                            }).format(totalVendas)}
                                        </td>
                                        <td colSpan="4"></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </>
                )}
                {/* Modal de Confirmação */}
                <ConfirmDialog
                    isOpen={isConfirmationModalOpen}
                    onClose={handleCancel}
                    onConfirm={() => {
                        if (cancelaTEFTransaction) {
                            confirmaCancelamentoTEF()
                        } else {
                            handleEmitirNFCe()
                        }
                    }}
                    onCancel={() => setIsConfirmationModalOpen(false)}
                    message={cancelaTEFTransaction ? "Você tem certeza que deseja cancelar esta transação?" : "Você tem certeza que deseja Emitir a NFCe desta venda ?"}
                />
                {/* Toast */}
                {toast.message && (
                    <Toast type={toast.type} message={toast.message} />
                )}
                {/* Renderização do modal de autorização */}
                <PermissionModalUI />

            </div>
        </div>

    );
}

export default ModalVendas;
